var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportingPsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 2.8125C5.625 1.88086 6.38086 1.125 7.3125 1.125H8.4375C9.36914 1.125 10.125 1.88086 10.125 2.8125V15.1875C10.125 16.1191 9.36914 16.875 8.4375 16.875H7.3125C6.38086 16.875 5.625 16.1191 5.625 15.1875V2.8125ZM0 9.5625C0 8.63086 0.755859 7.875 1.6875 7.875H2.8125C3.74414 7.875 4.5 8.63086 4.5 9.5625V15.1875C4.5 16.1191 3.74414 16.875 2.8125 16.875H1.6875C0.755859 16.875 0 16.1191 0 15.1875V9.5625ZM12.9375 3.375H14.0625C14.9941 3.375 15.75 4.13086 15.75 5.0625V15.1875C15.75 16.1191 14.9941 16.875 14.0625 16.875H12.9375C12.0059 16.875 11.25 16.1191 11.25 15.1875V5.0625C11.25 4.13086 12.0059 3.375 12.9375 3.375Z",
    fill: "#5C98EC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingPsvg);
export default __webpack_public_path__ + "static/media/ReportingPSVG.65749391d078d5ba10067980e4c2001e.svg";
export { ForwardRef as ReactComponent };